import { Config } from '@stencil/core';
import { sass } from '@stencil/sass';

const fontPath = '../node_modules/@allianz/allianz-neo/dist/allianz-neo';
const iconFontPath = '../node_modules/@allianz/allianz-icons/dist/demo';
const tokenPath = '../node_modules/@allianz/a1-design-tokens/dist/allianz/web';
const globalStylePath = 'src/styles/global.scss';

export const config: Config = {
  namespace: 'a1-elements',
  globalStyle: globalStylePath,
  plugins: [sass()],
  validatePrimaryPackageOutputTarget: true,
  devServer: {
    openBrowser: false, // prevent automatically opening browser when running playwright dev server
  },
  outputTargets: [
    {
      /* This output target generates static files ready for use in a website or web app.
       * To use the components, include the loader script tag and define the custom elements.
       *
       * <script type="module">
            import { defineCustomElements } from 'https://elements.cdn.allianz.com/loader/index.js';
            defineCustomElements();
         </script>
       *
       * Any custom elements can then be used, and will be lazy-loaded on demand.
       *
       * A token file is also required:
       * <link rel="stylesheet" href="https://design-tokens.cdn.allianz.com/0.6.2/allianz/web/tokens-light-lively-spacious.0.6.2.css" />
       */
      type: 'dist',
      esmLoaderPath: '../loader',
      isPrimaryPackageOutputTarget: true,
      empty: false,
      copy: [
        {
          src: `${iconFontPath}/Allianz-Icons.woff2`,
          dest: 'assets/fonts/Allianz-Icons.woff2',
        },
        {
          src: `${fontPath}/AllianzNeoW04-Bold.woff`,
          dest: 'assets/fonts/AllianzNeoW04-Bold.woff',
        },
        {
          src: `${fontPath}/AllianzNeoW04-Bold.woff2`,
          dest: 'assets/fonts/AllianzNeoW04-Bold.woff2',
        },
        {
          src: `${fontPath}/AllianzNeoW04-Regular.woff`,
          dest: 'assets/fonts/AllianzNeoW04-Regular.woff',
        },
        {
          src: `${fontPath}/AllianzNeoW04-Regular.woff2`,
          dest: 'assets/fonts/AllianzNeoW04-Regular.woff2',
        },
        {
          src: `${fontPath}/AllianzNeoW04-SemiBold.woff`,
          dest: 'assets/fonts/AllianzNeoW04-SemiBold.woff',
        },
        {
          src: `${fontPath}/AllianzNeoW04-SemiBold.woff2`,
          dest: 'assets/fonts/AllianzNeoW04-SemiBold.woff2',
        },
        { src: '../assets/images', dest: 'assets/images' },
        { src: `${tokenPath}/**/*.css`, dest: 'assets/tokens' },
      ],
    },
    {
      // this output target generates readme.md files for components during `npm run build`
      type: 'docs-readme',
      footer: '', // hide "Built with StencilJS"
    },
    {
      // this output target provides assets and Stencil components to Playwright
      type: 'www',
      serviceWorker: null, // disable service workers
      baseUrl: 'http://localhost/',
      copy: [
        { src: '**/*.html' },
        { src: '**/*.css' },
        {
          src: `${iconFontPath}/Allianz-Icons.woff2`,
          dest: 'assets/fonts/Allianz-Icons.woff2',
        },
        {
          src: `${fontPath}/AllianzNeoW04-Regular.woff`,
          dest: 'assets/fonts/AllianzNeoW04-Regular.woff',
        },
        {
          src: `${fontPath}/AllianzNeoW04-Regular.woff2`,
          dest: 'assets/fonts/AllianzNeoW04-Regular.woff2',
        },
        { src: '../assets/images', dest: 'assets/images' },
        { src: `${tokenPath}/**/*.css`, dest: 'assets/tokens' },
      ],
    },
    {
      // this output target generates a JSON file of the component
      // metadata for use with the Storybook Docs addon
      type: 'docs-json',
      file: 'docs/docs.json',
    },
  ],
  testing: {
    collectCoverage: true,
    coverageThreshold: {
      global: {
        branches: 80,
        functions: 80,
        lines: 80,
        statements: 80,
      },
    },
  },
  extras: {
    experimentalSlotFixes: true,
    experimentalScopedSlotChanges: true,
  },
};
